import {
  NormalQuestionBubble,
  QuestionBubbleHeader,
  QuestionBubbleLabel,
} from "@/Shared/Components/QuestionBubble";

function LocationsDockHoursQuestionBubble() {
  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>Pickup/Delivery Window</QuestionBubbleHeader>
          <QuestionBubbleLabel>
            Please put the full hours when this location will be open. If you
            have a preference for, say, morning delivery please add a note below
            instead.
          </QuestionBubbleLabel>
        </>
      }
      learnMoreUrl="https://help.freightsimple.com/using-freightsimple/booking-your-shipment/pickup-and-delivery-addresses-and-hours#hours"
    />
  );
}
export default LocationsDockHoursQuestionBubble;
